import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { FaFacebookF, FaInstagram, FaLinkedin, FaTiktok, FaYoutube, FaWhatsapp } from 'react-icons/fa';
import { businessLogic } from '../../lib/constants';
import FooterColumns from './FooterColumns';
import { BRAND_CURSOR_EVENT, brandCursorSupported, isBrandCursorDisabled, setBrandCursorDisabled } from '../../lib/brandCursor';

const Footer = () => {
   const { t } = useTranslation();
   // Interruptor del cursor animado (solo con ratón; en táctil no existe).
   const [cursorOff, setCursorOff] = useState(isBrandCursorDisabled);
   const [cursorSupported] = useState(brandCursorSupported);
   useEffect(() => {
      const sync = () => setCursorOff(isBrandCursorDisabled());
      window.addEventListener(BRAND_CURSOR_EVENT, sync);
      return () => window.removeEventListener(BRAND_CURSOR_EVENT, sync);
   }, []);
   return (
      <>
         <footer>
            <div className="footer__area grey-bg pt-100">
               <div className="footer__top pb-45">
                  <div className="container">
                     <div className="row">
                        <FooterColumns
                           columnClasses={[
                              "col-xl-2 col-lg-2 col-md-4 col-sm-6",
                              "col-xl-2 offset-xl-1 col-lg-2 offset-lg-1 col-md-4 col-sm-6",
                              "col-xl-2 offset-xl-1 col-lg-2 offset-lg-1 col-md-4 col-sm-6",
                              "col-xl-3 offset-xl-1 col-lg-3 offset-lg-1 col-md-4 col-sm-6",
                           ]}
                           linksClassName="footer__links"
                        />
                     </div>
                  </div>
               </div>

               <div className="footer__copyright">
                  <div className="container">
                     <div className="row align-items-center">
                        <div className="col-xl-6 col-lg-6 col-md-6">
                           <div className="footer__copyright-text">
                              <p>
                                 {businessLogic.copyright}
                                 <span style={{ margin: '0 10px' }}>·</span>
                                 <Link to="/terms">{t('footer_terms')}</Link>
                                 <span style={{ margin: '0 10px' }}>·</span>
                                 <Link to="/privacy">{t('footer_privacy')}</Link>
                                 <span style={{ margin: '0 10px' }}>·</span>
                                 <Link to="/cookies-policies">{t('footer_cookies')}</Link>
                                 <span style={{ margin: '0 10px' }}>·</span>
                                 <Link to="/legal-notice">{t('footer_legal_notice')}</Link>
                                 {cursorSupported && (
                                    <>
                                       <span style={{ margin: '0 10px' }}>·</span>
                                       <button
                                          type="button"
                                          onClick={() => setBrandCursorDisabled(!cursorOff)}
                                          aria-pressed={!cursorOff}
                                          style={{ background: 'none', border: 0, padding: 0, color: 'inherit', font: 'inherit', textDecoration: 'underline', cursor: 'pointer' }}
                                       >
                                          {cursorOff ? t('footer_cursor_on') : t('footer_cursor_off')}
                                       </button>
                                    </>
                                 )}
                              </p>
                              {/* Páginas legales que piden Google y Meta en la verificación de la app. */}
                              <p style={{ fontSize: '13px', marginTop: '6px' }}>
                                 <Link to="/data-deletion">{t('footer_data_deletion')}</Link>
                                 <span style={{ margin: '0 10px' }}>·</span>
                                 <Link to="/subprocessors">{t('footer_subprocessors')}</Link>
                                 <span style={{ margin: '0 10px' }}>·</span>
                                 <Link to="/dpa">{t('footer_dpa')}</Link>
                                 <span style={{ margin: '0 10px' }}>·</span>
                                 <Link to="/legal/history">{t('legal_previous_versions')}</Link>
                              </p>
                           </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6">
                           <div className="footer__social theme-social f-right">
                              <ul>

                              <li>
                                 <a href={`${businessLogic.linkedin}`} target="_blank" rel="noreferrer">
                                       <i ><FaLinkedin color='#7c74ff'/> </i>
                                       <i ><FaLinkedin/> </i>
                                    </a>
                                 </li>

                                 <li>
                                 <a href={`${businessLogic.instagram}`} target="_blank" rel="noreferrer">
                                       <i ><FaInstagram color='#7c74ff'/> </i>
                                       <i ><FaInstagram/> </i>
                                    </a>
                                 </li>

                                 <li>
                                 <a href={`${businessLogic.facebook}`} target="_blank" rel="noreferrer">
                                       <i ><FaFacebookF color='#7c74ff'/></i>
                                       <i ><FaFacebookF/></i>
                                    </a>
                                 </li>

                                 <li>
                                 <a href={businessLogic.tiktok} target="_blank" rel="noreferrer">
                                       <i ><FaTiktok color='#7c74ff'/></i>
                                       <i ><FaTiktok /></i>
                                    </a>
                                 </li>

                                 <li>
                                 <a href={businessLogic.youtube} target="_blank" rel="noreferrer">
                                       <i ><FaYoutube color='#7c74ff'/></i>
                                       <i ><FaYoutube /></i>
                                    </a>
                                 </li>

                                 <li>
                                 <a href={businessLogic.whatsappCommunityLink} target="_blank" rel="noreferrer" aria-label="WhatsApp Community" title="WhatsApp Community">
                                       <i ><FaWhatsapp color='#7c74ff'/></i>
                                       <i ><FaWhatsapp /></i>
                                    </a>
                                 </li>


                              </ul>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </footer>
      </>
   );
};

export default Footer;
